import { useCallback, useEffect, useState } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import BasicCard from '../../components/Card'
import Button from '@mui/material/Button'
import Add from '@mui/icons-material/Add'
import Close from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import * as yup from 'yup'
import { ButtonWrapper, CardWrapper } from './styles'
import API from '../../services/api'
import { useNotify } from 'react-admin'

const createBotSchema = yup.object().shape({
  name: yup.string().required(JSON.stringify({ field: 'name', message: 'Campo Obrigatório' })),
  botToken: yup
    .string()
    .required(JSON.stringify({ field: 'botToken', message: 'Campo Obrigatório' })),
})

const Bots = () => {
  const notify = useNotify()

  const [isCreatingBot, setIsCreatingBot] = useState(false)

  const [bots, setBots] = useState([])

  const [name, setName] = useState('')
  const [botToken, setBotToken] = useState('')

  const [errors, setErrors] = useState<any>({})

  const clearValues = () => {
    setName('')
    setBotToken('')
    setErrors({})
  }

  const closeCreateDialog = () => {
    clearValues()
    setIsCreatingBot(false)
  }

  const clearFieldError = (field: string) => {
    const curErrors = structuredClone(errors)
    delete curErrors[field]
    setErrors(curErrors)
  }

  const parseValidationError = (error: string) => {
    const errorObj = JSON.parse(error)

    setErrors({
      [errorObj.field]: errorObj.message,
    })
  }

  const loadBots = useCallback(async () => {
    try {
      const response = await API.get('/bots?limit=100')

      setBots(response.data.bots.data)
    } catch (error) {
      notify('Ocorreu um erro ao carregar a lista, tente novamente.', { type: 'error' })
    }
  }, [notify])

  useEffect(() => {
    loadBots()
  }, [loadBots])

  const handleCreateBot = async () => {
    try {
      await createBotSchema.validate({
        name,
        botToken,
      })

      await API.post('/bots', {
        name,
        botToken,
      })

      notify('Bot cadastrado com sucesso!', { type: 'success' })
      closeCreateDialog()
      loadBots()
    } catch (error: any) {
      if (error.name === 'ValidationError') {
        return parseValidationError(error.message)
      }

      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
      closeCreateDialog()
    }
  }

  return (
    <Card>
      <CardHeader title="Bots" />
      <CardContent>
        <ButtonWrapper>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => setIsCreatingBot(true)}
            // disabled={bots.length > 0}
          >
            Criar
          </Button>
        </ButtonWrapper>

        {bots.map((bot: any, i: number) => {
          if (i > 0) {
            return (
              <CardWrapper key={i}>
                <BasicCard
                  title={bot.name}
                  authenticated={bot.authenticated}
                  status={bot.status}
                  botId={bot.id}
                  expiresAt={bot.expires_at}
                  loadBots={loadBots}
                />
              </CardWrapper>
            )
          } else {
            return (
              <BasicCard
                key={i}
                title={bot.name}
                authenticated={bot.authenticated}
                status={bot.status}
                botId={bot.id}
                expiresAt={bot.expires_at}
                loadBots={loadBots}
              />
            )
          }
        })}
      </CardContent>

      <Dialog open={isCreatingBot} onClose={closeCreateDialog}>
        <DialogTitle>Criar bot</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Caso tenha alguma dúvida, consulte a wiki ou o suporte.
          </DialogContentText>
          <TextField
            margin="dense"
            label="Nome"
            type="text"
            error={!!errors['name']}
            fullWidth
            variant="standard"
            helperText={errors['name'] || 'Nome para identificação no sistema'}
            value={name}
            onChange={(ev) => {
              clearFieldError('name')
              setName(ev.target.value)
            }}
          />
          <TextField
            margin="dense"
            label="Bot Token"
            type="text"
            error={!!errors['botToken']}
            fullWidth
            variant="standard"
            helperText={errors['botToken'] || 'Token gerado pelo BotFather'}
            value={botToken}
            onChange={(ev) => {
              clearFieldError('botToken')
              setBotToken(ev.target.value)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Close />}
            onClick={closeCreateDialog}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => handleCreateBot()}
          >
            Criar
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  )
}

export default Bots
